import { render } from "./ui-years.vue?vue&type=template&id=776412cb&ts=true"
import script from "./ui-years.vue?vue&type=script&lang=ts"
export * from "./ui-years.vue?vue&type=script&lang=ts"

import "./ui-years.vue?vue&type=style&index=0&id=776412cb&lang=less"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__